<template>
  <div class="my-4 border-t border-gray-300"></div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
